import { forwardRef } from 'react';
import type { LiveEventCustomAction } from 'autogen/swagger/all';
import openBambuser from 'components/live/openBambuser';
import { CustomActionButton } from '../shared/styles';
import type { CustomActionProps } from '../shared/types';

type LiveEventActionProps = { action: LiveEventCustomAction } & CustomActionProps;

const LiveEventAction = forwardRef<HTMLButtonElement, LiveEventActionProps>(
    ({ action, onClick, ...restProps }, ref) => (
        <CustomActionButton
            ref={ref}
            type="button"
            onClick={(e) => {
                if (onClick) {
                    onClick(e);
                }
                openBambuser(action.liveEventId);
            }}
            {...restProps}
        />
    )
);

export default LiveEventAction;
